import React, { useEffect, useState } from 'react';
import { Select, SelectProps } from 'antd';
import { getRequest, ResponseDataType } from 'api';

const { Option } = Select;

export interface ClassLevelSelectProps extends Omit<SelectProps<any>, 'options'> {
  schoolId?: number | string;
  levels?: string[];
  onClassLevelsLoaded?: (levels: string[]) => void;
  showAllOption?: boolean;
  allOptionLabel?: string;
  customFormatLabel?: (level: string) => string;
}

export const ClassLevelSelect: React.FC<ClassLevelSelectProps> = ({
  schoolId: propSchoolId,
  levels: propLevels,
  onClassLevelsLoaded,
  showAllOption = false,
  allOptionLabel = 'Tất cả các khối',
  customFormatLabel,
  placeholder = 'Chọn khối',
  allowClear = true,
  style,
  ...rest
}) => {
  const [levels, setLevels] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const schoolId = propSchoolId || localStorage.getItem('schoolId');

  useEffect(() => {
    if (propLevels !== undefined) return;
    if (!schoolId) return;

    const fetchLevels = async () => {
      setLoading(true);
      try {
        const res: ResponseDataType<string[]> = await getRequest(
          `/cms/class/get-all-class-levels?schoolId=${schoolId}`
        );
        if (res?.code === 200 && Array.isArray(res.info)) {
          setLevels(res.info);
          onClassLevelsLoaded?.(res.info);
        }
      } catch (err) {
        console.error('Lỗi khi tải danh sách khối:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLevels();
  }, [schoolId, propLevels]);

  const displayLevels = propLevels !== undefined ? propLevels : levels;

  const formatLabel = (level: string) => {
    if (customFormatLabel) return customFormatLabel(level);
    return level;
  };

  return (
    <Select
      placeholder={placeholder}
      allowClear={allowClear}
      loading={loading}
      style={{ width: 140, ...style }}
      {...rest}
    >
      {showAllOption && <Option value="">{allOptionLabel}</Option>}
      {displayLevels.map((lvl) => (
        <Option key={lvl} value={lvl}>
          {formatLabel(lvl)}
        </Option>
      ))}
    </Select>
  );
};
